import st from "@/styles/CreditPage.module.scss";
import clsx from "clsx";
import CommonClass from "@/utils/common.ts";
import {CircularProgress} from "@mui/material";
import {useTranslation} from "react-i18next";
import PaymentsInterface from "@/types_and_interfaces/payments_interface.ts";
import React, {useState} from "react";
import {isMobile} from "react-device-detect";
// import PlusIcon from "@/svg/PlusIcon.tsx";

interface Props {
    payments:PaymentsInterface[] | undefined | null
}

const PaymentHistory:React.FC<Props> = ({payments}) => {
    const {t} = useTranslation()
    const [open_graphic, set_open_graphic] = useState<boolean>(false)
    
    
    return (Array.isArray(payments) && payments.length) ? (
        <div className={st.history}>
            
            <div
                className={st.header}
                onClick={() => {
                    if (isMobile) {
                        set_open_graphic((x) => !x)
                    }
                }}
            >
                
                <strong>
                    {t("payment_history")}
                </strong>
                
                {/*<button*/}
                {/*    onClick={() => {*/}
                {/*        if (!isMobile) {*/}
                {/*            set_open_graphic((x) => !x)*/}
                {/*        }*/}
                {/*    }}*/}
                {/*    className={clsx(st.button, open_graphic && st.active)}*/}
                
                {/*>*/}
                {/*    <span>*/}
                {/*        {!open_graphic ? t("show_history") : t("hide_history")}*/}
                {/*    </span>*/}
                {/*    */}
                {/*    <PlusIcon/>*/}
                {/*</button>*/}
            </div>
            
            <div className={clsx(st.graphic, open_graphic && st.active)}>
                {Array.isArray(payments) ? (
                    <>
                        {payments.length ? (
                            <table>
                                <thead>
                                <tr>
                                    <th>{t("payment_date")}</th>
                                    <th>{t("payment_method")}</th>
                                    {/*<th>{t("type")}</th>*/}
                                    <th>{t("paid_amount")}</th>
                                </tr>
                                </thead>
                                
                                {window.innerWidth < CommonClass.breakpoints.breakpoint3 ? (
                                    <tbody className={st.tbody}>
                                        {payments.map((inst, i) => {
                                            return (
                                                
                                                <tr key={`installment_${i}`}>
                                                    <td className={st.inst}>
                                                        
                                                        <div className={st.row}>
                                                            
                                                            <span className={st.field_name}>
                                                                {t("payment_date")}
                                                            </span>
                                                            
                                                            <span className={st.val}>
                                                                {inst.payment_date}
                                                            </span>
                                                        
                                                        </div>
                                                        
                                                        <div className={st.row}>
                                                            
                                                            <span className={st.field_name}>
                                                                {t("payment_method")}
                                                            </span>
                                                            
                                                            <span className={st.val}>
                                                                {inst.location}
                                                                
                                                                {inst.img.length ?(
                                                                    <div className={st.img_container}>
                                                                        <img src={inst.img} alt="img"/>
                                                                    </div>
                                                                ) : (
                                                                    <div className={st.img}/>
                                                                )}
                                                                
                                                            </span>
                                                        
                                                        </div>
                                                        
                                                        {/*<div className={st.row}>*/}
                                                        {/*    */}
                                                        {/*    <span className={st.field_name}>*/}
                                                        {/*        {t("type")}*/}
                                                        {/*    </span>*/}
                                                        {/*    */}
                                                        {/*    <span className={st.val}>*/}
                                                        {/*        {t(inst.type.toLowerCase())}*/}
                                                        {/*    </span>*/}
                                                        
                                                        {/*</div>*/}
                                                        
                                                        <div className={st.row}>
                                                            
                                                            <span className={st.field_name}>
                                                                {t("paid_amount")}
                                                            </span>
                                                            
                                                            <span className={st.val}>
                                                                {`${inst.amount} ${t("currency")}`}
                                                            </span>
                                                        
                                                        </div>
                                                    
                                                    </td>
                                                </tr>
                                            
                                            )
                                        })}
                                    </tbody>
                                ) : (
                                    <tbody>
                                        {payments.map((inst, i) => {
                                            return (
                                                
                                                <tr key={`installment_${i}`}>
                                                    <td>{inst.payment_date}</td>
                                                    
                                                    <td className={st.method}>
                                                        {inst.img.length ? (
                                                            <div className={st.img_container}>
                                                                <img src={inst.img} alt="img"/>
                                                            </div>
                                                        ) : (
                                                            <div className={st.img}/>
                                                        )}
                                                        
                                                        {inst.location}
                                                    </td>
                                                    
                                                    {/*<td>{t(inst.type.toLowerCase())}</td>*/}
                                                    
                                                    <td>{`${CommonClass.formatMoneyAmount(Number(inst.amount)) } ${t("currency")}`}</td>
                                                    {/*<td>Row 1, Cell 3</td>*/}
                                                </tr>
                                            
                                            )
                                        })}
                                    </tbody>
                                )}
                            
                            </table>
                        ) : (
                            <span className={st.emptyness_span}>
                                {t("empty_payment_history")}
                            </span>
                        )}
                    
                    </>
                ) : <CircularProgress color={"success"}/>}
            </div>
            
        </div>
    ) : null
}

export default PaymentHistory